import Collapse from "bootstrap/js/dist/collapse";
import Tooltip from "bootstrap/js/dist/tooltip";
import Modal from "bootstrap/js/dist/modal";
import Dropzone from "dropzone";

import { collectCarOptionals, goToFirstError, domReady } from "../../js/core";

window.Dropzone = Dropzone;

const tooltipTriggerList = document.querySelectorAll(
  '[data-bs-toggle="tooltip"]'
);
const tooltipList = [...tooltipTriggerList].map(
  (tooltipTriggerEl) => new Tooltip(tooltipTriggerEl)
);

collectCarOptionals();

function photoUpload(elements) {
  const previewTemplate =
    document.getElementById("photoTemplate").content.firstElementChild
      .innerHTML;
  function initDropzone(el) {
    const previewsContainer = el.querySelector(".dropzone-previews");
    const clickable = el.querySelector(".file-upload");
    return new window.Dropzone(el, {
      clickable: clickable,
      createImageThumbnails: false,
      headers: {
        "Dropzone-Request": "true",
        "X-CSRF-Token": document.querySelector('meta[name="X-CSRF-Token"]').content
      },
      previewTemplate: previewTemplate,
      acceptedFiles: "image/*,application/pdf",
      capture: "camera",
      maxFiles: 1,
      maxFilesize: window.appConstants.maxFilesize,
      previewsContainer: previewsContainer,
      init: function () {
        if (el.dataset.fileName) {
          var mockFile = {
            name: el.dataset.fileName,
            size: "1000",
            type: "image/jpeg",
            accepted: true, // required if using 'MaxFiles' option
          };
          this.files.push(mockFile); // add to files array
          this.emit("addedfile", mockFile);
          this.emit("complete", mockFile);
          // this.displayExistingFile(
          //   {
          //     name: el.dataset.fileName,
          //   },
          //   ""
          // );
          el.classList.add("dz-uploaded");
          this.element.removeEventListener('click', this.listeners[1].events.click);
          this.element.removeEventListener('drop', this.listeners[0].events.drop);
          this.element.addEventListener('drop', preventDrop )
        }
      },
      error: function (file, message) {
        const dropzoneInstance = this;
        dropZoneError(el, file, message, dropzoneInstance);
      },
      success(file, response) {
        el.classList.remove("dz-processing");
        el.classList.add("dz-uploaded");

        if (file.previewElement) {
          file.previewElement.classList.add("dz-success");
        }
        el.querySelector('input[name="attachment-id"]').value =
          response.data.attachment_id;
        dropZoneValids(elements);
        this.element.removeEventListener('click', this.listeners[1].events.click);
        this.element.removeEventListener('drop', this.listeners[0].events.drop);
        this.element.addEventListener('drop', preventDrop )
      },
      processing(file) {
        el.classList.add("dz-processing");
        if (file.previewElement) {
          file.previewElement.classList.add("dz-processing");
          if (file._removeLink) {
            return (file._removeLink.innerHTML = this.options.dictCancelUpload);
          }
        }
      },
      canceled(file) {
        el.classList.remove("dz-processing");
        return this.emit("error", file, this.options.dictUploadCanceled);
      },
      removedfile: function (file) {
        if (file.status === "error" || file.status === "canceled") {
          if (
            file.previewElement != null &&
            file.previewElement.parentNode != null
          ) {
            file.previewElement.parentNode.removeChild(file.previewElement);
          }
          el.classList.remove("dz-uploaded");
          el.classList.remove("dz-processing");
          el.classList.remove("dz-form-error");
          dropZoneValids(elements);
          return this._updateMaxFilesReachedClass();
        } else {
          fetch(window.appRoutes["user:dossier:car:attachment:remove"], {
            method: "post",
            body: new FormData(el),
            headers: new Headers({
              Accept: "application/json",
            }),
          })
            .then((response) => {
              if (response.ok) {
                if (
                  file.previewElement != null &&
                  file.previewElement.parentNode != null
                ) {
                  file.previewElement.parentNode.removeChild(
                    file.previewElement
                  );
                }
                el.classList.remove("dz-uploaded");
                el.classList.remove("dz-processing");
                el.classList.remove("dz-form-error");
                dropZoneValids(elements);
                return this._updateMaxFilesReachedClass();
              } else {
                alert("Fail, retry later");
              }
            })
            .catch((error) => {
              console.warn({ error });
            });
        }
        this.element.addEventListener('click', this.listeners[1].events.click);
        this.element.addEventListener('drop', this.listeners[0].events.drop);
        this.element.removeEventListener('drop', preventDrop )
      },
    });
  }
  const photosDropzone = [...elements].map(initDropzone);
  dropZoneValids(elements);
}

var preventDrop = function(e) {
  e.preventDefault();
};

const fileUploadList = document.querySelectorAll(".dropzone-photo");
fileUploadList.length && photoUpload(fileUploadList);

function dropZoneError(el, file, message, dropzoneInstance) {
  el.classList.remove("dz-processing");
  el.classList.add("dz-form-error");
  if (file.previewElement) {
    file.previewElement.classList.add("dz-error");
    if (typeof message !== "string" && message.message) {
      message = message.message;
    }
    for (let node of file.previewElement.querySelectorAll(
      "[data-dz-errormessage]"
    )) {
      node.textContent = message;
    }
  }
  setTimeout(() => {
    dropzoneInstance.removeFile(file);
  }, 5000);
  // if(el.dropzone.files.length){
  //   el.classList.add("dz-uploaded");
  // }
}

const switchCheck = document.getElementById("flexSwitchCheckFileUpload");
switchCheck && switchCheck.addEventListener('change', dropZoneValids)

function dropZoneValids(elements) {
  console.log('check');
  const btn = document.getElementById("js-enable");
  const switchCheck = document.getElementById("flexSwitchCheckFileUpload");
  const needTwoFiles = switchCheck.checked;
  const required = [
    "dropzone-registrationFront",
    "dropzone-Frontale",
    "dropzone-Posteriore",
    "dropzone-Latodestro",
    "dropzone-Latosinistro",
    "dropzone-Interni",
  ];
  if(needTwoFiles){
    required.push('dropzone-registrationBack')
  }
  const enable = required.every((id) => {
    const fileLength = document.getElementById(id).dropzone.files.length
    return Boolean(fileLength)
  })
  
  if (enable) {
    btn.removeAttribute("disabled");
  } else {
    btn.setAttribute("disabled", "");
  }
}

function damageUpload(el) {
  const previewTemplate =
    document.getElementById("photoTemplate").content.firstElementChild
      .innerHTML;

  const previewsContainer = el.querySelector(".dropzone-previews");
  const clickable = el.querySelector(".file-upload");
  const damageType = el.querySelector("#damageType");
  const damagePhotoContainer = el.querySelector("#damagephotocontainer");
  const submitButton = el.querySelector("button[type=submit]");
  
  new window.Dropzone(el, {
    clickable: clickable,
    createImageThumbnails: false,
    headers: {
      "Dropzone-Request": "true",
      "X-CSRF-Token": document.querySelector('meta[name="X-CSRF-Token"]').content
    },
    previewTemplate: previewTemplate,
    acceptedFiles: "image/*",
    capture: "camera",
    maxFiles: 1,
    maxFilesize: window.appConstants.maxFilesize,
    previewsContainer: previewsContainer,
    autoProcessQueue: false,
    error: function (file, message) {
      const dropzoneInstance = this;
      dropZoneError(el, file, message, dropzoneInstance);
    },
    init: function () {
      const myDropzone = this;

      damageType.addEventListener("change",function(ev){
        if (damageType.value == "Meccanico"){
          submitButton.removeAttribute("disabled");
          damagePhotoContainer.classList.add("d-none");
        }else{
          if(myDropzone.files.length){
            submitButton.removeAttribute("disabled");
          } else {
            submitButton.setAttribute("disabled", true);
          }
          damagePhotoContainer.classList.remove("d-none");
        }
      });

      this.element.addEventListener("submit", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (damageType.value == "Meccanico"){
          console.log("sono un danno meccanico");
          let xhttp = new XMLHttpRequest();
          xhttp.onreadystatechange = function(){
            if(xhttp.readyState == 4 && xhttp.status == 200) {
              el.reset();
              myDropzone.removeAllFiles();
              loadDamages(damagesContainer);
            }
          };
          xhttp.open("POST", submitButton.closest("form").action, true);
          xhttp.setRequestHeader('X-CSRF-Token', document.querySelector('meta[name="X-CSRF-Token"]').content);
          var data = new FormData();
          data.append('attachment-subject', damageType.value);
          data.append('description', el.querySelector("#damageDesc").value);
          data.append('attachment-type', 'damage');          
          xhttp.send(data);

        }
        else{          
          myDropzone.processQueue();
        }
        
      });

      this.on("addedfile", function () {
        el.classList.remove("dz-form-error");
        el.classList.add("dz-processing");
        el.querySelector("button[type=submit]").removeAttribute("disabled");
      });
      this.on("removedfile", function () {
        el.classList.remove("dz-form-error");
        el.classList.remove("dz-processing");
        el.querySelector("button[type=submit]").setAttribute("disabled", true);
      });
      this.on("success", function (files, response) {
        el.reset();
        myDropzone.removeAllFiles();
        loadDamages(damagesContainer);
      });
    },
  });
}
const damageUploadEl = document.querySelector(".dropzone-damage");
damageUploadEl && damageUpload(damageUploadEl);

function loadDamages(damagesContainer) {
  damagesContainer.textContent = "";
  fetch(window.appRoutes["user:dossier:car:damage:list"], {
    method: "get",
    headers: new Headers({
      Accept: "application/json",
    }),
  })
    .then((response) => response.json())
    .then((responseJson) => {
      responseJson.data.damages.forEach((element) => {
        const tpl = document
          .getElementById("damageTemplate")
          .content.cloneNode(true).firstElementChild;
        tpl.querySelector("[data-dz-name]").textContent = element.type;
        tpl.querySelector("[data-dz-desc]").textContent = element.description;
        tpl.querySelector("[data-dz-remove]").addEventListener("click", () => {
          const data = new FormData();
          data.append("attachment-id", element.id);
          data.append("attachment-type", "damage");
          fetch(window.appRoutes["user:dossier:car:attachment:remove"], {
            method: "post",
            body: data,
            headers: new Headers({
              Accept: "application/json",
              "X-CSRF-Token": document.querySelector('meta[name="X-CSRF-Token"]').content
            }),
          }).then(() => {
            loadDamages(damagesContainer);
          });
        });
        damagesContainer.append(tpl);
        if (responseJson.data.damages.length) {
          if (!document.getElementById("flexSwitchCheckDamage").checked) {
            document.getElementById("flexSwitchCheckDamage").click();
          }
        }
      });
    });
}
const damagesContainer = document.querySelector(".damages");
damagesContainer && loadDamages(damagesContainer);

const versionCollapse = document.querySelectorAll(".togglerequiredoncollapse");
if (versionCollapse) {
  versionCollapse.forEach((vc) => {
    console.log("adding listeners to ", vc);
    let inputfields = vc.querySelectorAll("input, select, textarea");
    vc.addEventListener("hide.bs.collapse", (event) => {
      inputfields.forEach((inputfield) => {
        inputfield.required = false;
        console.log("remove");
      });
    });
    vc.addEventListener("show.bs.collapse", (event) => {
      inputfields.forEach((inputfield) => {
        inputfield.required = true;
        console.log("re-add");
      });
    });
  });
}

function deleteCar(event){
  event.preventDefault();
  event.stopPropagation();
  
  let element = event.target;
  let xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function(){
    if (this.readyState == 4 && this.status == 200) {
      try {
        callresult = JSON.parse(this.responseText);
      } catch (e) {
        console.error("eccezione!!", e);
        alert("Si è verificato un errore di comunicazione con il server");
      }
      if (callresult.res) {location.reload();}
      else{alert(callresult.msg)}
    }
  };
  xhttp.open("POST", element.dataset["href"], true);
  xhttp.setRequestHeader('X-CSRF-Token', document.querySelector('meta[name="X-CSRF-Token"]').content);
  xhttp.send();
}

document.querySelectorAll("a.js--deletecar").forEach((element) => {
  element.addEventListener("click", deleteCar );
});


domReady(function () {
  console.log("scroll to first error?", goToFirstError());
});
